<template>
  <div>
    <h2 class="teammates-title h5">{{ $t('People working in') }} “{{ company }}”</h2>
    <div class="teammates-container spacey-16">
      <div v-for="teammate in teammates" :key="teammate.id" class="teammate">
        <Avatar
          class="mr-8"
          :size="24"
          :name="teammate.name"
          :pic="teammate.files_urls.avatar_thumnail"
        />
        <div class="teammate-name text-sm grey-900">
          {{ teammate.name }}
        </div>
        <div class="teammate-position text-sm grey-500">
          {{ teammate.position }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/avatars/Avatar';

  export default {
    name: 'Teammates',
    components: {
      Avatar,
    },
    props: {
      company: {
        type: String,
        required: true,
      },
      teammates: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .teammates-title {
    margin-bottom: 8px;
  }

  .teammates-container {
    background-color: $grey50;
    border-radius: 4px;
    padding: 12px 16px;
    max-height: 148px;
    overflow: hidden;
  }

  .teammate {
    display: flex;
    align-items: center;
  }

  .teammate-name {
    margin-right: 4px;
  }
</style>
